import { render } from "./HtmlpageRender.vue?vue&type=template&id=877be058&scoped=true"
import script from "./HtmlpageRender.vue?vue&type=script&lang=js"
export * from "./HtmlpageRender.vue?vue&type=script&lang=js"

import "./HtmlpageRender.vue?vue&type=style&index=0&id=877be058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877be058"]])

export default __exports__